import { render, staticRenderFns } from "./ModalReceiveOrder.vue?vue&type=template&id=2b93c48a&"
import script from "./ModalReceiveOrder.vue?vue&type=script&lang=js&"
export * from "./ModalReceiveOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports